import i18next from 'i18next';
import { SalesForceIntegration } from 'infrastructure/enums';

export interface ISalesForceIntegration {
  id: SalesForceIntegration;
  name: string;
}

export const salesForceIntegrationDataSource = (): ISalesForceIntegration[] => {
  return [
    {
      id: SalesForceIntegration.Disabled,
      name: i18next.t('salesForceIntegrations.disabled'),
    },
    {
      id: SalesForceIntegration.Inherited,
      name: i18next.t('salesForceIntegrations.inherited'),
    },
  ];
};
